import { atom } from 'jotai';
import { RestaurantItem } from '~/types/restaurant';

let _restaurantId: string | null = null;

export const restaurantAtom = atom<RestaurantItem | null>(null);

export const selectRestaurantShowAtom = atom(false);

export default {
  setRestaurantId(val: string) {
    _restaurantId = val;
  },
  getRestaurantId() {
    return _restaurantId;
  },
};
